import { PageHeader } from '@evertrue/et-components';
import PauseForm from './pause-form';
import HolidayTooltip from 'components/tooltip/holiday-tooltip';
import { useFeatureFlag } from 'entities/helpers/use-feature-flag';

const JourneySettingsController = () => {
  const { flagEnabled, loaded: holidayBlackoutFlagLoaded } = useFeatureFlag('holidayBlackout');
  // Default to prior/safer behavior (holidays respected) until the flag resolves.
  const holidayBlackoutEnabled = holidayBlackoutFlagLoaded ? flagEnabled : true;

  return (
    <>
      <PageHeader title="Pause Cadences and Tasks" className="pause-journey-header" />
      <p className="pause-journey-warning">
        Pausing cadences will freeze all your cadences and tasks until you return. You can use this feature when you are
        heading out on some well deserved time off, are out of office visiting donors, or have a busy week of meetings.
        Don't forget to set a pause for any departmental holidays!
      </p>
      <p className="pause-journey-warning">
        You can resume your cadences at any time, or set a return date on any weekday to automatically resume your tasks
        when you log on for the day.
      </p>
      {holidayBlackoutFlagLoaded && (
        <p className="pause-journey-warning">
          <strong>
            {holidayBlackoutEnabled
              ? 'Note: Cadence intervals will automatically account for weekends and U.S. federal holidays. No cadence steps will fall due on those days.'
              : 'Note: Cadence intervals will automatically account for weekends. No cadence steps will fall due on those days.'}
          </strong>
          {holidayBlackoutEnabled && <HolidayTooltip />}
        </p>
      )}
      <PauseForm holidayBlackoutEnabled={holidayBlackoutEnabled} />
    </>
  );
};

export default JourneySettingsController;
